"use strict";
//Chinese
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': '输入',
  'AUDIOCONTROLS-OUTPUT-HEADING': '输出',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': '取消',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': '保存',
  'BACK-BTN-LABEL': '背部',
  'CALLCONTROLS-MUTE-BTN-LABEL' : '静音',
  'CALLCONTROLS-HOLD-BTN-LABEL' : '保留',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : '音频',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : '键盘',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : '转接',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : '新呼叫',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : '挂机',
  'CALLLIST-NOCALL' : '没有活动呼叫',
  'CANCEL-BTN-LABEL' : '取消',
  'EMAIL-PLACEHOLDER' : '电子邮件地址',
  'INCOMINGCALL-HEADER' : '来电',
  'INCOMINGCALL-ACCEPT' : '接听',
  'INCOMINGCALL-DECLINE' : '拒接来电',
  'INCOMINGCALL-VOICEMAIL' : '发送到语音信箱',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' 请输入电邮地址',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : '输入密码',
  'LOGIN-CHECKBOX-LABEL' : '记住我',
  'LOGIN-FORGOTPASSWORD-LINK' : '忘记密码？',
  'LOGIN-SIGNIN-BTN-LABEL' : '登录',
  'LOGIN-FORGOTPW-INFO-TEXT' : '输入您的电子邮件地址来重置您的密码。',
  'LOGIN-INPUT-PASSWORD-ERROR' : '请输入完整的密码',
  'LOGIN-INPUT-EMAIL-ERROR' : '请输入有效的电子邮件',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': '密码必须匹配',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : '重设',
  'LOGIN-RESETPW-INFO-TEXT' : ', 请更改您的密码。密码应至少包含一个字母，没有空格，不与@开始，8个或更多字符',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : '新密码',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : '重复输入密码',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : '更改',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : '取消',
  'SETTINGS-VIEWALERT-BTN-LABEL' : '查看警报',
  'SETTINGS-VERSION' : '版本 ',
  'SETTINGS-HELPDOC-BTN-LABEL' : '帮助文档',
  'SETTINGS-CHECKBOX-LABEL' : '启用',
  'SETTINGS-CHECKBOX-HEADER' : '窗口始终置顶？',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : '关闭警报',
  'SETTINGS-LOGOUT-BTN-LABEL' : '登出',
  'SETTINGS-SELECT-EXTENSION-HEADER': '分机',
  'SETTINGS-SELECT-RINGTONE-HEADER': '铃声',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': '输入设备',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': '输出设备',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': '接口主题',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': '界面语言',
  'CALLHISTORY-BACK-BTN-LABEL' : '返回',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : '清除',
  'CALLHISTORY-HEADER' : '记录',
  'CALLHISTORY-NO-HISTORY-MSG' : '无通话记录',
  'ALERTLOG-SETTINGS-BTN-LABEL' : '设置',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : '清除',
  'ALERTLOG-HEADER' : '警报',
  'ALERTLOG-NO-ALERT-MSG' : '没有可用的警报',
  'UTILITIES-STATUS-ONHOLD' : '等候接听',
  'UTILITIES-STATUS-MUTED' : '静音',
  'UTILITIES-STATUS-ACTIVE' : '使用中',
  'UTILITIES-STATUS-DIALING' : '拨号中',
  'ALERTITEM-HEADING-LOGIN' : '登录',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : '您输入的用户名或密码不正确。',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : '丢失网络连接。检查连接状态。',
  'DIALINPUT-PLACEHOLDER-TEXT' : '输入要拨打的号码',
  'CALLDETAILS-HOLD' : '等候接听',
  'CALLDETAILS-MUTED': '静音',
  'CALLLIST-STATUS-ACTIVE': '使用中',
  'CALLLIST-STATUS-DIALING': '拨号中',
  'CALLHISTORY-STATUS-FAILED': '失败的',
  'HEADING-STATUS-CONNECTED' : '连接的',
  'HEADING-STATUS-OFFLINE' : '离线',
  'BLIND-BTN-LABEL': '盲',
  'ATTENDED-BTN-LABEL': '咨询',
  'SOFTPHONE-DTMF-COMMANDS': "输入号码",
  'ARIA-LOGIN-SIGNIN-BTN': "登录按钮",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "忘记密码按钮",
  'ARIA-CANCEL-BTN': "取消按钮",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "重置密码按钮",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "现在不行按钮",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': '后退按钮',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': '清除历史记录按钮',
  'ARIA-SETTINGS-LOGOUT-BTN': "退出按钮",
  'ARIA-SETTINGS-VIEWALERT-BTN': "查看警报按钮",
  'ARIA-SETTINGS-HELPDOC-BTN': "帮助文档按钮",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "更改密码按钮",
  'ARIA-BACKSPACE-BTN': '退格键',
  'ARIA-DIALING-INPUT-FIELD': '拨号输入字段',
  'ARIA-HEADER': '标头',
  'ARIA-CLEAR-ALERTS-BUTTON': '清除警报按钮',
  'ARIA-ALERT-LIST': '警报列表',
  'ARIA-CHECKBOX': '复选框',
  'ARIA-SAVE-BTN': '保存按钮',
  'ARIA-INPUT-FIELD': '输入字段',
  'ARIA-INPUT': '输入',
  'ARIA-KEYPAD': '键盘',
  'ARIA-KEY': '键',
  'ARIA-AUDIO-SLIDER': '音频滑块',
  'ARIA-AUDIO-SLIDER-CONTROL': '音频滑块控件',
  'ARIA-MENU-ITEM': '菜单项',
  'ARIA-DROP-DOWN-MENU': '下拉式菜单',
  'ARIA-BADGE-BUTTON': '徽章按钮',
  'ARIA-CALL-DETAIL': '呼叫细节',
  'ARIA-OPEN-SETTINGS-BUTTON': '打开设置按钮',
  'UPDATE-HEADER': '更新可用',
  'UPDATE-MSG': '你想现在重新启动应用程序？',
  'UPDATE-POSTPONE-BUTTON': '推迟（一分钟）',
  'UPDATE-UPDATE-BUTTON': '更新',
  'ARIA-UPDATE-POSTPONE-BUTTON': '推迟按钮',
  'ARIA-UPDATE-UPDATE-BUTTON': '更新按钮',
  'LOGIN-INPUT-SHOW': '显示',
  'LOGIN-INPUT-HIDE': '隐藏',
  'ACTIVECALL-STATUS-RINGING': '正在振铃',
  'ACTIVECALL-STATUS-ACTIVE': '使用中',
  'ACTIVECALL-STATUS-DIALING': '拨号中',
  'ACTIVECALL-STATUS-FAILED': '失败',
  'CALLHISTORY-TODAY': '今天',
  'CALLHISTORY-YESTERDAY': '昨天',
  'ALERT_FORGOT_PASSWORD': '忘记密码',
  'ALERT_SETTINGS_WILL_APPLY': '电话使用中;将于空闲时设置.',
  'ALERT_DIALING_OPTIONS': '拨号选项',
  'ALERT_DIALING_OPTIONS_BODY': '缺少拨号计划选项',
  'ALERT_LOGIN': '登录',
  'ALERT_SOFTPHONE_EXTENSION': '没有软电话分机',
  'ALERT_MORE_INFORMATION': '欲了解更多信息，请访问：',
  'ALERT_LOST_CONNECTION': '丢失网络连接。检查连接状态。',
  'ARIA-PLAY-BTN': '播放按钮',
  'ARIA-STOP-BTN': '停止按钮',
  'CONTACTS-STATUS-ONLINE': '线上',
  'CONTACTS-STATUS-OFFLINE': '离线',
  'CONTACTS-STATUS-BUSY': '忙',
  'CONTACTS-STATUS-UNKNOWN': '未知',
  'LABELLEDINPUT-LABEL-EMAIL': "电子邮件地址",
  'LABELLEDINPUT-LABEL-PASSWORD': "密码",
  'LABELLEDINPUT-LABEL-TEXT': "文本",
  'LABELLEDINPUT-HINT-EMAIL': "在下面输入有效的电子邮件地址.",
  'LABELLEDINPUT-HINT-PASSWORD': "在下面输入有效的密码.",
  'LABELLEDINPUT-HINT-TEXT': "在下面输入文字.",
  'ARIA-ICON-AREA': '图标区域',
  'SETTINGS-ADVANCED-LOGGING': "高级日志记录",
  'APPMENU-SETTINGS-BTN-LABEL': "打开设置",
  'APPMENU-HELP-BTN-LABEL': "帮助文档",
  'APPMENU-LOGOUT-BTN-LABEL': "登出",
  'APPMENU-VERSION': "版 ",
  'HEADER-SETTINGS-TITLE': "设置",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "通知",
  'SETTINGS-APPEARANCE-BTN-LABEL': "出现",
  'SETTINGS-CONTACTS-BTN-LABEL': "往来",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "故障排除",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "调整您如何接收更新。",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "改变应用程序的外观和感觉。",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "导入您的联系人",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "帮助您找出错误的工具",
  'ARIA-BACK-BTN-LABEL': "背部",
  'HEADER-BACK-ARIA-LABEL' : '背部',
  'ENTITYLIST-SEARCH-FOUND': "发现.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "项目",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': '新集团',
  'ENTITYLIST-NO-CONTACTS-FOUND': '找不到联系人',
  'ENTITYLIST-TRY-IMPORTING': '尝试导入或添加联系人.',
  'ZEROSTATE-IMPORT-BTN-LABEL': '进口',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': '在设置中输入要发送或导入联系人列表的号码.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "搜索联系人",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : '添加一个数字',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': '没有联系方式',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': '添加一个数字开始',
  'ARIA-CARD-DETAILS-EDIT': '编辑',
  'ARIA-CARD-DETAILS-DELETE': '删除',
  'SETTINGS-DEVICES-BTN-LABEL': "设备",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "更改您的设备配置方式.",
  'HEADER-CONTACTS-ARIA-LABEL' : "往来",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "故障排除",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "启用高级日志",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "启用后，应用程序将创建高级日志，以帮助诊断应用程序错误。",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : '高级日志记录',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "警报",
  "SETTINGS-VIEW-ALERTS-TITLE" : "查看警报",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "访问警报和日志的记录。",
  "SETTINGS-NOTIFICATIONS-TITLE": "铃声",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "更改呼入语音呼叫的铃声.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "默认",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "光",
  'APPMENU-DARK-THEME-BTN-LABEL': "黑暗",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "总在最前面",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "母鸡已启用应用程序将始终显示在您的其他应用程序之上。",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "总在最前面?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "主题",
  'SETTINGS-THEMES-DESCRIPTION': "主题改变了应用程序的整体外观。",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "语言",
  'SETTINGS-LANGUAGE-DESCRIPTION': "更改语言会在整个应用程序中进行更改。",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "设备",
  "SETTINGS-CATEGORY-HEADER-NOTIFICATIONS" : "往来",
  "SETTINGS-CATEGORY-HEADER-APPEARANCE" : "出现",
  "SETTINGS-CATEGORY-HEADER-CONTACTS" : "往来",
  'SETTINGS-INPUT-DEVICE-TITLE': "输入设备",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "设置要用于输入的音频设备.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "输出设备",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "设置要用于输出的音频设备.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "导入您的联系人",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "选择下面的选项来导入联系人。",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "示例CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "按下面的按钮将下载CSV文件示例。.",
  'SETTINGS-CONTACTS-BACKUP': '备用',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "按下面的按钮将下载您的联系人的CSV备份。 这是在进口之前推荐的。",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': '下载样品',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "进口",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "进口",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': '下载备份',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': '增加联系人',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "取消",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "删除",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "您确定要删除此联系人吗？?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "完成此操作将永久删除当前联系人的信息. ",
  'CONTACT-DETAILS-FORM-ERROR': '下面的表单中的字段有错误。',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': '个人信息',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': '名字',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': '输入名字',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': '姓',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': '输入姓氏',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': '公司',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': '输入公司名称',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': '电话号码',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': '添加电话',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': '取消',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': '保存',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': '新联系人',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': '更改联系资料',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': '此字段不能留空',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'数',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'请输入有效的10位数字',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'输入号码...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'首选？',
  'CONTACT-DETAILS-FORM-SELECT-HOME': '家',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': '商业',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': '移动',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': '其他',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': '标签',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': '选择要呼叫的号码',
  'NUMBER-SELECTION-MODAL-PREFERRED': '首选',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'请输入有效的号码'

};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-zh.js